module.exports = require('./ContentServerEditorLinkView');
